const HealthcareProviderTestIDs = {
  introTitle: 'healthcare-provider-info-title',
  introTitleText: 'healthcare-provider-info-title-text',
  introDescription: 'healthcare-provider-info-description',
  introDescriptionText: 'healthcare-provider-info-description-text',

  yesOption: 'healthcare-provider-yes',
  noOption: 'healthcare-provider-no',

  detailsHeader: 'provider-details-header',
  detailsTitleText: 'provider-details-title-text',
  detailsSubtitle: 'provider-details-subtitle',
  detailsSubtitleText: 'provider-details-subtitle-text',

  registeredFieldLabel: 'registered-field-label',
  registeredFieldLabelText: 'registered-field-label-text',
  registeredFieldDropdown: 'registered-field-dropdown',

  otherFieldLabelContainer: 'other-registered-field-label-container',
  otherFieldLabelText: 'other-registered-field-label-text',
  otherFieldInput: 'other-registered-field-input',
  otherFieldError: 'other-registered-field-error',
  otherFieldErrorText: 'other-registered-field-error-text',

  registeredStateLabel: 'registered-state-label',
  registeredStateLabelText: 'registered-state-label-text',
  registeredStateDropdown: 'registered-state-dropdown',

  licenseLabel: 'license-number-label',
  licenseLabelText: 'license-number-label-text',
  licenseInput: 'license-number-input',
  licenseError: 'license-number-error',
  licenseErrorText: 'license-number-error-text',
  licenseReadyOnlyInput: 'license-number-label-read-only-input',
  licenseReadyOnlyInputText: 'license-number-label-read-only-input-text',

  cancelButton: 'cancel-healthcare-provider-button',
  saveButton: 'save-healthcare-provider-button',
  errorBanner: {
    container: 'healthcare-provider-error-banner',
  },
  errorContainer: 'health-care-provider-error-container',
  errorTitle: 'health-care-provider-error-title',
  errorSubTitle: 'health-care-provider-error-sub-title',
};

export default HealthcareProviderTestIDs;
